module.exports = __webpack_public_path__ + "img/club_05.49919bfe.png";